import type { OwnedDbOperationResult } from "@9amhealth/shared";
import { ensureOwnership, getDb, runForOwner } from "./DbService";
import type { CachedJourneyContent } from "./dbTypes";

const makeKey = (journey: string, language: string): string =>
  `${journey}:${language}`;

export const DbJourneyContentService = {
  async get(
    journey: string,
    language: string
  ): Promise<CachedJourneyContent | undefined> {
    await ensureOwnership();
    const db = getDb();
    return db.journeyContent.get(makeKey(journey, language));
  },

  async putForOwner(
    expectedOwnerId: string | null,
    journey: string,
    language: string,
    data: Record<string, unknown>,
    lastFetchAt: number,
    metaKey: string
  ): Promise<OwnedDbOperationResult<void>> {
    return runForOwner(expectedOwnerId, (db) =>
      db.transaction("rw", db.journeyContent, db.meta, async () => {
        await db.journeyContent.put({
          key: makeKey(journey, language),
          journey,
          language,
          data
        });
        await db.meta.put({ key: metaKey, lastFetchAt });
      })
    );
  }
};
